const purple = '#5236AB';

const styles = {
  labelText: {
    fontWeight: 600,
    mb: 0.25,
    color: '#6e6e6e',
  },

  fieldInput: {
    mb: 1.25,
    '& .MuiFormHelperText-root': {
      position: 'static',
      height: 'auto',
      margin: 0,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },

  dateInput: {
    '& .MuiOutlinedInput-input': {
      color: 'inherit',
    },
  },

  actionsBox: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 2,
  },

  buttonBase: {
    textTransform: 'none',
    height: '100%',
  },

  purpleButton: {
    backgroundColor: purple,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#f0f0f0',
      color: purple,
    },
  },

  dateOutlinedInput: {
    '& .MuiInputBase-input': {
      color: '#757575',
    },
  },

  errorOutlined: {
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: '#d32f2f',
    },
    '& .MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: '#d32f2f',
      borderWidth: 1.5, 
    },
  },
};

export default styles;
